
const styles = {
    gridHeader: {
      padding: "0px 0px!important"
    },
    cardHeaderProcessoVenda:{
        background:'#427d98',borderRadius:'5px',height:'80px'
    },
    boxProcess:{
        position:'relative'
    },
    boxItem:{
        color:'white',fontSize:'13px',textAlign:'center',zIndex:'1',position:'absolute',left:'0',right:'0'
    },
    iconItem:{
        margin:'0 auto',marginBottom:'5px',borderRadius:'50px',
    },
    icoSize:{
        fontSize:'14px'
    },
    lineProcessRight:{
        height:'3px',left:'50%',right:'0px',background:'gray',position:'absolute',top:'10px'
    },
    lineProcessLeft:{
        height:'3px',left:'0',right:'50%',background:'gray',position:'absolute',top:'10px'
    },
    lineLight:{
        background:'#99bdce'
    },
    lineDark:{
        background:'#124258'
    },
    boxItem:{
        color:'white',fontSize:'13px',textAlign:'center',zIndex:'1',position:'absolute',left:'0',right:'0'
    },
    iconItemLight:{
        margin:'0 auto',marginBottom:'10px',borderRadius:'50px',
    },
    iconCheck:{
        width:'25px',height:'25px',background:'#124258',
    },
    iconUnCheck:{
        width:'15px',height:'15px',background:'#99bdce',marginTop:'5px',
    },
    noneCheck:{
        display:'none'
    }

};

export default styles;